export const categories = [
  "overall",
  "idol_artist",
  "vtuber_creator",
  "character_ip",
  "sports_team",
  "local_place",
  "product_project",
] as const;

export type Category = (typeof categories)[number];
export type CampaignCategory = Exclude<Category, "overall">;
export type BoardPeriod = "weekly" | "lifetime";
export type CampaignStatus = "nomination" | "pending" | "active" | "paused" | "withdrawn" | "suspended";

export const categoryLabels: Record<Category, string> = {
  overall: "総合",
  idol_artist: "アイドル・アーティスト",
  vtuber_creator: "VTuber・配信者・クリエイター",
  character_ip: "アニメ・漫画・ゲーム・キャラクター",
  sports_team: "スポーツ・チーム",
  local_place: "店舗・地域・観光",
  product_project: "プロダクト・ブランド・プロジェクト",
};

export interface CampaignSummary {
  id: string;
  slug: string;
  name: string;
  category: CampaignCategory;
  description: string;
  status: CampaignStatus;
  verified: boolean;
  artworkUrl: string | null;
  officialUrl: string;
  lifetimeRank: number | null;
  lifetimeJpy: number;
  weeklyRank: number | null;
  weeklyJpy: number;
  weeklySupporters: number;
  latestWeeklySupportAt: string | null;
  outboundClicks: number;
  hourlyClicks: number;
  lifetimeSponsorJpy: number;
  weeklySponsorJpy: number;
  earliestWeeklySupportAt: string | null;
  promotionReserveAccruedJpy: number;
  promotionReserveSpentJpy: number;
  promotionReserveRemainingJpy: number;
  promotionStatus: "not_eligible" | "available" | "planning" | "approved" | "fulfilled" | "overdue";
  authorizationEndsAt: string | null;
}

export interface BoardResponse {
  period: BoardPeriod;
  category: Category;
  generatedAt: string;
  entries: CampaignSummary[];
}

export interface CampaignDetail extends CampaignSummary {
  longDescription: string;
  rightsHolderName: string;
  territories: string[];
  permittedMediaUses: string[];
  milestones: Array<{ thresholdJpy: number; label: string; reachedAt: string | null }>;
  recentBoosts: Array<{ id: string; amountJpy: number; supporterName: string | null; sponsorVerified: boolean; settledAt: string }>;
}

export interface ApiError {
  error: { code: string; message: string; field?: string };
}

export interface ListingPreview {
  kind: "website" | "x";
  displayName: string;
  officialUrl: string;
  iconDataUrl: string | null;
  iconSourceUrl: string | null;
  notice: string;
}
